module.exports = __webpack_public_path__ + "static/media/contrax-white-logo.dabc2bfd.svg";